import { z } from 'zod';
import { ClaimAssignmentChronicleTypeSchema, ClaimV1ChronicleTypeSchema, ClaimV2ChronicleTypeSchema, EstimateChronicleTypeSchema, } from './claimChronicles.js';
export const ClaimReportingChronicleTypeSchema = z.enum([
    ...ClaimV1ChronicleTypeSchema.options,
    ...ClaimV2ChronicleTypeSchema.options,
    ...EstimateChronicleTypeSchema.options,
    ...ClaimAssignmentChronicleTypeSchema.options,
    'latestEstimateUploaded',
]);
export const ClaimReportingChronicleType = ClaimReportingChronicleTypeSchema.enum;
export const isClaimReportingChronicle = (chronicle) => ClaimReportingChronicleTypeSchema.safeParse(chronicle.type).success;
